import _objectWithoutProperties from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as"],
    _excluded2 = ["width", "height"];
import { Primitive as e } from "@radix-ui/react-primitive";
import * as r from "react";
import t from "@babel/runtime/helpers/esm/extends";
export var Arrow = /*#__PURE__*/r.forwardRef(function (i, n) {
  var _i$as = i.as,
      s = _i$as === void 0 ? o : _i$as,
      a = _objectWithoutProperties(i, _excluded);
  /*#__PURE__*/


  return r.createElement(e, t({}, a, {
    as: s,
    ref: n
  }));
});
var o = /*#__PURE__*/r.forwardRef(function (e, o) {
  var _e$width = e.width,
      i = _e$width === void 0 ? 10 : _e$width,
      _e$height = e.height,
      n = _e$height === void 0 ? 5 : _e$height,
      s = _objectWithoutProperties(e, _excluded2);
  /*#__PURE__*/


  return r.createElement("svg", t({}, s, {
    ref: o,
    width: i,
    height: n,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), /*#__PURE__*/r.createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
/*#__PURE__*/

export var Root = Arrow;